module.exports = __webpack_public_path__ + "static/img/21.8639838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/21.png
// module id = nsHY
// module chunks = 1